const toFixedAmount = (value: number) => parseFloat(value.toFixed(2))

export const feePercentToRate = (feePercent: number) => feePercent / 100

export const calculateFoundationBuyPreview = (
    quantity: number,
    price: number,
    feePercent: number
) => {
    if (!quantity || !price) {
        return { receiveAmount: null, expectedFee: null }
    }

    const feeRate = feePercentToRate(feePercent)

    return {
        receiveAmount: toFixedAmount(quantity / price),
        expectedFee: toFixedAmount(quantity * feeRate)
    }
}

export const calculatePartnerSellPreview = (
    quantity: number,
    price: number,
    feePercent: number
) => {
    if (!quantity || !price) {
        return null
    }

    const feeRate = feePercentToRate(feePercent)

    return toFixedAmount(quantity * price * (1 - feeRate))
}
